import { css } from '@emotion/react';
import { Colors, Icon, Link, Typography } from '@zapier/design-system';
import { isolateComponent } from '@zapier/style-encapsulation';
import { emitUserInteractionEvent } from '../../../utils/avroEvents';
const Styles = {
    root: css({
        display: 'flex',
        gap: 30,
    }),
    link: css(Object.assign(Object.assign({}, Typography.smallPrint1Medium), { textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 6, color: Colors.neutral800, '&:hover': {
            color: Colors.zapier,
            textDecoration: 'none',
        }, '&:focus': {
            outline: `1px solid ${Colors.blue}`,
            outlineOffset: '1px',
            textDecoration: 'none',
        } })),
};
export const MegaMenuFooter = (props) => {
    const { links } = props;
    const handleEvent = (text, eventType) => {
        emitUserInteractionEvent({
            event_action: eventType,
            option_selected: `MegaNavFooter: ${text}`,
        });
        if (eventType === 'click' && props.onCloseMenu)
            props.onCloseMenu();
    };
    return (isolateComponent("ul", { css: Styles.root }, links === null || links === void 0 ? void 0 : links.map((link) => (isolateComponent("li", { key: link.text },
        isolateComponent(Link, { color: null, css: Styles.link, href: link.href || undefined, onClick: () => handleEvent(link.text, 'click'), onMouseEnter: () => handleEvent(link.text, 'hover'), target: link.target },
            link.icon && (isolateComponent(Icon, { name: typeof link.icon === 'object' ? link.icon.selected : link.icon, size: 14 })),
            link.text))))));
};
//# sourceMappingURL=MegaMenuFooter.js.map
// @zapier/universal-layout@8.3.1 (41acce620)
